import React from "react";
import {
    Box,
    IconButton,
    Dialog,
    Typography,
    Divider,
    TextField,
    FormControl,
    Select,
    MenuItem,
    InputLabel,
    Autocomplete,
    ToggleButton,
    ToggleButtonGroup,
    Tabs,
    Tab,
    RadioGroup,
    FormControlLabel,
    Radio,
    FormLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./youtubePopup.css";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import ReusableButton from "../../Reusable/PrimaryButton/PrimaryButton";
import { youtubeConnectors, uploadYoutubeVideo, youTubeChannelList, updateYoutubeData } from "../../../services/apiService";
import { CopyAllOutlined } from "@mui/icons-material";
import { showToast } from "../../Toast/CommonToast";
import SecondaryButton from "../../Reusable/SecondaryButton/SecondaryButton";
import LoaderWithBackdrop from "../../Loader/loader";
import { useLocation } from "react-router-dom";
import moment from "moment-timezone";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from "dayjs";

interface YouTubePopupProps {
    isOpen: boolean;
    onClose: () => void;
    videoUrl?: string;
    titlePage?: string;
    selectedPopupItem?: any; // Optional prop for selected item
}

const YouTubePopup: React.FC<YouTubePopupProps> = ({
    isOpen,
    onClose,
    videoUrl,
    titlePage,
    selectedPopupItem
}) => {
    const [connected, setConnected] = React.useState(false);
    const [publish, setPublish] = React.useState(false);
    const userId: string = localStorage.getItem("userId") || "";
    const [pathUrl, setPathUrl] = React.useState<string | null>(null);
    const [publishUrl, setPublishUrl] = React.useState<string | null>(null);
    const [channelList, setChannelList] = React.useState<any[]>([]);
    const [channelId, setChannelId] = React.useState<string>("");
    // const [connectedChannel, setConnectedChannel] = React.useState<string | null>(null);
    const [hoveredChannelId, setHoveredChannelId] = React.useState<string | null>(null);
    const [inputValue, setInputValue] = React.useState("");
    const [VideoData, setVideoData] = React.useState<any>({
        title: "",
        description: "",
        categories: "",
        tags: [],
        seletedCategory: null,
        availableCategories: [],

    })
    const [privateStatus, setPrivateStatus] = React.useState<string>("");
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const location = useLocation();

    const [activeTab, setActiveTab] = React.useState(0);
    const [selectedTimezone, setSelectedTimezone] = React.useState(""
    );
    // const timezones = moment.tz.names();
    const [userPickedTime, setUserPickedTime] = React.useState(false);

    const getUserTimezone = () => {
        try {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        } catch (error) {
            return 'UTC';
        }
    };
    React.useEffect(() => {
        if (!selectedTimezone || selectedTimezone === "Please Select TimeZone") {
            const userTz = getUserTimezone();
            setSelectedTimezone(userTz);
        }
    }, [selectedTimezone]);
    

const [scheduleDateTime, setScheduleDateTime] = React.useState<Date | null>(new Date());
let formattedDate = '';
let formattedTime = '';
if (scheduleDateTime) {
  formattedDate = dayjs(scheduleDateTime).format("YYYY-MM-DD");
  formattedTime = dayjs(scheduleDateTime).format("HH:mm:ss");
}
    const [isForKids, setIsForKids] = React.useState<string>("yes");

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    const connectedStatus:any = localStorage.getItem("connectedYoutube") || false;
  const handleChange = (event:any, newPrivacy:any) => {
        if (newPrivacy !== null) {
            setPrivateStatus(newPrivacy);
        }
    };
    React.useEffect(() => {
  let timer: NodeJS.Timeout | undefined;

  // Only update time if user has NOT picked a custom time
  if (isOpen && !userPickedTime) {
    console.log("updating time...");
    setScheduleDateTime(new Date());
    timer = setInterval(() => {
      setScheduleDateTime(new Date());
    }, 60000);
  }
  return () => {
    if (timer) clearInterval(timer);
  };
}, [isOpen, userPickedTime]);
const isFutureSchedule = scheduleDateTime && dayjs(scheduleDateTime).isAfter(dayjs());




    const youTubeChannelListAPI = React.useCallback(async () => {
        try {
            const response = await youTubeChannelList(userId)
            setChannelList(response?.data?.channels || []);
            //    setConnectedChannel(response?.data?.connected || null);
            if (!channelId && response?.data?.channels?.length) {
                const connected = response.data.channels.find((c: any) => c.connected);
                if (connected) {
                    setChannelId(connected.channelId);
                    if (connected.tokens) {
                        localStorage.setItem("youtubeAccessToken", connected.tokens.access_token || "");
                        localStorage.setItem("youtubeRefreshToken", connected.tokens.refresh_token || "");
                        localStorage.setItem("connectedYoutube", connected.connected || "");
                    }
                }
            }
        }
        catch (error) {
            console.error("Error fetching YouTube channels:", error);
        }
    }, [userId, channelId]);

    React.useEffect(()=> {
        youTubeChannelListAPI();
    },[isOpen, pathUrl ,youTubeChannelListAPI])

    const handleConnect = async () => {
        localStorage.setItem('youtubeLocation', location.pathname)
        try {
            const connectResponse = await youtubeConnectors("connect", userId);
            if (connectResponse?.data?.url) {
                const url = connectResponse?.data?.url || null;
                if (url) {
                    window.location.href = url;
                    setPathUrl(url);
                }
            }
        } catch (error) {
            console.error("Error connecting to YouTube:", error);
        }
    };

    console.log("videoUrl", selectedPopupItem)

    // Utility to always return an array of strings
    const toStringArray = (tags: any) => {
        if (Array.isArray(tags)) return tags.map(String);
        if (typeof tags === 'string' && tags.trim() !== '') return [tags];
        return [];
    };

    function getUtcScheduledTime(date: string, time: string, timezone: string) {
    if (!date || !time || !timezone) return "";
  // date: "2025-09-18", time: "14:30:00", timezone: "Asia/Kolkata"
  const local = moment.tz(`${date} ${time}`, "YYYY-MM-DD HH:mm:ss", timezone);
    return local.utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
}

    const handlePublish = async () => {
        if (!videoUrl) return;
        if (isFutureSchedule === false && userPickedTime) {
    showToast("You cannot schedule a video in the past. Please select a future date and time.", "error");
    return;
}
        const accessToken = localStorage.getItem("youtubeAccessToken") || "";
        const refreshToken = localStorage.getItem("youtubeRefreshToken") || "";
        try {
            const payload={
                videoId: selectedPopupItem?._id || "",
                userId: userId,
                title: VideoData?.title || "",
                description: VideoData?.description || "",
                accessToken: accessToken,
                refreshToken: refreshToken,
                privacyStatus: selectedTimezone ? 'Private' : privateStatus,
                channelId: channelId,
                tags: toStringArray(VideoData?.tags),
                categoryId: VideoData.seletedCategory?.id || "" ,
                madeForKids: isForKids === "yes",
            }
            const schedulePayload ={
                ...payload,
                madeForKids: isForKids === "yes",
                 scheduledAt: (isFutureSchedule && userPickedTime)
        ? getUtcScheduledTime(formattedDate, formattedTime, selectedTimezone)
        : "",
    timezone: (isFutureSchedule && userPickedTime)
        ? selectedTimezone
        : ""
            }
            setIsLoading(true);
            const response = await uploadYoutubeVideo(selectedTimezone ? schedulePayload : payload );
            setIsLoading(false);
            showToast(response?.data?.message , "success");
            if (response?.status === true) {
                setPublish(true);
                setPublishUrl(response?.data?.youtubeUrl || null);
            } else {
                setIsLoading(false);
                showToast(response?.data?.message , "success");
                console.error("Failed to publish video:", response?.data?.message);
            }
        } catch (error:any) {
            if(error?.statusCode === 401 || error?.message === "YouTube channel connection expired. Please reconnect to channel.") {
                setIsLoading(false);
            showToast(error?.message , "error");
                setConnected(false);
                return;
            }
            setIsLoading(false);
            showToast(error?.message , "error");
            console.error("Error publishing video:", error);
        }
    }

    const handleCopyLink = (link: string) => {
        console.log("link", link)
        if (link) {
            navigator.clipboard.writeText(link)

        }
    };

    const handleChannelChange = (event: any) => {
        const selectedId = event.target.value as string;
        setChannelId(selectedId);
        const selectedChannel = channelList.find((c) => c.channelId === selectedId);
        if(selectedChannel){
            console.log("selectedChannel", selectedChannel)
            localStorage.setItem("youtubeAccessToken", selectedChannel?.tokens?.access_token || "");
            localStorage.setItem("c", selectedChannel?.tokens?.refresh_token || "");
        }
    };

    // Helper to extract YouTube video ID from URL
    const getYouTubeVideoId = (url: string) => {
        const regExp = /(?:youtube[.]com\/(?:.*v=|v\/|embed\/|shorts\/)|youtu[.]be\/)([\w-]{11})/;
        const match = url.match(regExp);
        return match ? match[1] : null;
    };

    const handleConnectChannelId = async (type: string, channelId: string) => {
        localStorage.setItem('youtubeLocation', location.pathname)
        try {
            const connectResponse = await youtubeConnectors(type, userId, channelId);
            await youTubeChannelListAPI();
        if(type === 'disconnect') {
                // Remove tokens from localStorage on disconnect
                localStorage.removeItem("youtubeAccessToken");
                localStorage.removeItem("youtubeRefreshToken");
                localStorage.setItem("connectedYoutube", connectResponse?.data?.connected || "false");
                setChannelId("");
                setConnected(false);
            }
        if(connectResponse?.data?.url){
                const url = connectResponse?.data?.url || null;
                if (url) {
                    window.location.href = url; // Open in same tab
                    setPathUrl(url);
                }
            }
    }catch(error) {
            console.error("Error connecting to channel:", error);
        }
    }
    const isAnyChannelConnected = () => Array.isArray(channelList) && channelList.some((c) => c.connected);

    const handleNextPage = () => {
        if (isAnyChannelConnected()) {
            // Optionally, select the first connected channel if none is selected
            if (!channelId) {
                const firstConnected = channelList.find((c) => c.connected);
                if (firstConnected) setChannelId(firstConnected.channelId);
            }
            setConnected(true);
            getAllUploadData();
        } else {
            console.log("Please connect at least one channel to proceed.");
        }
    };

    const handlePreviousPage = () => {
        setConnected(false);
        // Always refresh channel list on Previous
        youTubeChannelListAPI();
    };

    // Move getAllUploadData above useEffect and wrap in useCallback
    const getAllUploadData = React.useCallback(async () => {
        const accessToken = localStorage.getItem("youtubeAccessToken") || "";
        const refreshToken = localStorage.getItem("youtubeRefreshToken") || "";
    if(accessToken === "" || refreshToken === "") return;   
        setIsLoading(true);

        try {
            const response = await updateYoutubeData(selectedPopupItem?._id, accessToken, refreshToken);
            setIsLoading(false);
            if (response) {
            showToast(response?.data?.message , "success");
                setIsLoading(false);
                setVideoData({
                    title: response?.data?.title || "",
                    description: response?.data?.description || "",
                    categories: response?.data?.seletedCategory?.title || "",
                    tags: response?.data?.tags || [],
                    seletedCategory: response?.data?.seletedCategory || null,
                    availableCategories: response?.data?.availableCategories || [],
                })
            } else {
                setIsLoading(false);
            showToast(response?.data?.message , "error");
            }
    } catch (error:any) {
            setIsLoading(false);
        showToast(error?.message , "error");
            console.error("Error updating YouTube data:", error);
        }
    }, [selectedPopupItem?._id,]);

    const getUniqueTimezones = () => {
        const allTimezones = moment.tz.names();
        const timezoneMap = new Map();

        allTimezones.forEach((tz) => {
            const offset = moment.tz(tz).utcOffset();
            const offsetStr = moment.tz(tz).format("Z");

            // Only keep one timezone per unique offset
            if (!timezoneMap.has(offset)) {
                timezoneMap.set(offset, {
                    name: tz,
                    offset: offset,
                    offsetStr: offsetStr,
                    label: `(GMT${offsetStr}) ${tz.replace(/_/g, ' ')}`
                });
            }
        });

        // Sort by offset (GMT-12 to GMT+14)
        return Array.from(timezoneMap.values()).sort((a, b) => a.offset - b.offset);
    };

    const uniqueTimezones = React.useMemo(() => getUniqueTimezones(), []);

    return (
        <Box >
            {isLoading &&  <LoaderWithBackdrop open={isLoading} />}
            <Dialog open={isOpen}  onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
                      }} className={`${publish ? "youtubeContainerPublish":"youtubeContainer"}`} >
                <Box className="youTubeheader">
                    <Box className="headerContent">
                        <IconButton onClick={onClose} className="backButton">
                            <ShareOutlinedIcon />
                        </IconButton>
                        <Typography variant="h6" className="youtubeText">
                            Sharing {titlePage || "YouTube Video"}
                        </Typography>
                    </Box>
                    {/* <Button className="copyLinkButton">
                        <InsertLinkIcon />
                        <Typography variant="body1" className="copyText">
                            Copy Link
                        </Typography>
                    </Button> */}
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Divider className="ytubeDivider" />
               { !publish ? (
                    <>
                        {!connected && (
                            <Box pt={2} pl={4} pr={4}>
                                <Box className="youtubeContent">
                        <img src={"/assets/YTube.svg"} alt="YouTube" className={`${connectedStatus || channelList?.length> 0 ? 'youtubeConnect' : 'youtube'}`} onClick={handleConnect}/>
                        <img src={"/assets/FB.svg"} alt="Facebook" className='disabledIcon'/>
                                    <img src={"/assets/X.svg"} alt="Twitter/X" className="disabledIcon" />
                                </Box>
                                <Divider className="ytubeDivider" />
                            </Box>
                        )}
                        <Box pl={4} pr={4} pt={2} pb={2}>
                            {!connected ? (
                                <>   <Box className="youtubeConnector">
                                    <Box>
                                        <Typography variant="h6" className="youtubeText">
                                            Connect to Youtube
                                        </Typography>
                                        <Typography variant="h6" className="youtubeDescription">
                                            Allow Showcasaai to publish to my youtube channel
                                        </Typography>
                                    </Box>
                                    <ReusableButton onClick={handleConnect}>
                                        Add Account
                                    </ReusableButton>

                                </Box>
                                    <Box mt={4} mb={4}>
                                        {channelList.length > 0 &&
                                            channelList.map((channel, index) => {
                                            return(
                                                    <Box className="channelBox" key={index}>
                                                        <Typography key={index} className="channelName" gutterBottom>
                                                            {channel?.channelName}
                                                        </Typography>
                                            {channel?.connected  ? (
                                                            <ReusableButton
                                                                className={`${hoveredChannelId === channel.channelId ? ' disconnected' : 'connect-button connected'}`}
                                                                onMouseEnter={() => setHoveredChannelId(channel.channelId)}
                                                                onMouseLeave={() => setHoveredChannelId(null)}
                                                                onClick={() => handleConnectChannelId('disconnect', channel.channelId)}
                                                            >
                                                                {hoveredChannelId === channel.channelId ? 'Disconnect' : 'Connected'}
                                                            </ReusableButton>
                                            ):(
                                                <ReusableButton onClick={()=>handleConnectChannelId('connect',channel.channelId)}>
                                                                Connect
                                                            </ReusableButton>
                                            ) }
                                                    </Box>

                                                )
                                            })}
                                    </Box>
                                </>
                            ) : (
                                <>
                                    <Box className="youtubeConnector">
                                        <Box className="IconHeader">
                                            <img src={"/assets/Youtubeconnected.svg"} alt="YouTube" className="ytube" />
                                            <div className="youtubeHeaderIcon">
                                                <Typography variant="h6" className="youtubeText">
                                                    Connected to Youtube
                                                </Typography>
                                                <Typography variant="h6" className="youtubeDescription">
                                                    Details needed to publish to youtube.
                                                </Typography>
                                            </div>

                                        </Box>
                                        <Box className="toggleContainer">
                                            <Typography variant="subtitle2" sx={{ color: "#ccc" }}>
                                                Privacy Status<span style={{ color: "red" }}>*</span>
                                            </Typography>

                                            <ToggleButtonGroup
                                                value={privateStatus}
                                                exclusive
                                                onChange={handleChange}
                                                aria-label="privacy status"
                                                sx={{
                                                    backgroundColor: "#2b2b50",
                                                    borderRadius: "10px",
                                                    border: '1.5px solid #fff',

                                                    ".MuiToggleButton-root": {
                                                        color: "#fff",
                                                        border: "none",
                                                        padding: "6px 16px",
                                                        borderRadius: 0,
                                                        textTransform: "none",
                                                        borderRight: '1.5px solid #fff',
                                                        fontFamily: 'var(--font-family-primary)',
                                                        fontWeight: 400,
                                                        fontSize: '14px',
                                                        "&.Mui-selected": {
                                                            backgroundColor: "#69319D",
                                                            color: "#fff",

                                                        },
                                                        "&:hover": {
                                                            backgroundColor: "#69319D",

                                                        },
                                                        "&:first-of-type": {
                                                            borderRadius: "10px 0 0 10px",
                                                        },
                                                        "&:last-of-type": {
                                                            borderRadius: "0 10px 10px 0",
                                                        },
                                                    },
                                                }}
                                            >
                                                <ToggleButton value="Public">Public</ToggleButton>
                                                <ToggleButton value="Private">Private</ToggleButton>
                                                <ToggleButton value="Unlisted">Unlisted</ToggleButton>
                                            </ToggleButtonGroup>
                                        </Box>
                                    </Box>
                                    {/*Tab Section  */}


                                    <Box className="youtubePublish">
                                        <Box className="width50">
                                            <Box className='ytubeTabSection'>
                                                <Tabs className="ytubeTabs" value={activeTab} onChange={handleTabChange}>
                                                    <Tab label="Video Details" className="ytubeTab" />
                                                    <Tab label="Schedule Time" className="ytubeTab" />
                                                </Tabs>
                                            </Box>
                                   {activeTab === 0 ?(
                                                <>
                                                    <Box mb={2} mt={2}>
                                                        <TextField
                                                            sx={{ width: "90% !important" }}
                                                            label="Video Title"
                                                            variant="outlined"
                                                            className="textField"
                                                            value={VideoData?.title}
                                                            required
                                                            onChange={e => setVideoData((prev: any) => ({ ...prev, title: e.target.value }))}
                                                        />
                                                    </Box>
                                                    <Box mb={2}>
                                                        <TextField
                                                            sx={{ width: "90% !important" }}
                                                            label="Video Description"
                                                            variant="outlined"
                                                            className="textField"
                                                            multiline
                                                            rows={2}
                                                            value={VideoData?.description}
                                                            required
                                                            onChange={e => setVideoData((prev: any) => ({ ...prev, description: e.target.value }))}
                                                        />
                                                    </Box>
                                                    <Box className="youtubeCategory">
                                                        <Box mb={2} className="width44">
                                                            <FormControl sx={{ width: "100% !important" }} className="textField" required>
                                                                <InputLabel>ChannelName</InputLabel>
                                                                <Select
                                                                    value={channelId}
                                                                    label="ChannelName"
                                                                    onChange={handleChannelChange}
                                                                // disabled={!channelList.length || !connectedChannel}
                                                                >
                                                                    {channelList && channelList.map((channel, index) => (
                                                                        <MenuItem key={index} value={channel.channelId}>
                                                                            {channel?.channelName}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            </FormControl>
                                                        </Box>
                                        <Box mb={2}  className="width44">
                                                            <FormControl sx={{ width: "100% !important" }} className="textField" required>
                                                                <InputLabel>Category</InputLabel>
                                                                <Select
                                                                    value={VideoData.seletedCategory ? VideoData.seletedCategory.id : ""}
                                                                    label="Category"
                                                                    onChange={e => {
                                                                        const selected = VideoData.availableCategories.find((cat: any) => cat.id === e.target.value);
                                                                        setVideoData((prev: any) => ({
                                                                            ...prev,
                                                                            seletedCategory: selected || null,
                                                                            categories: selected ? selected.title : ""
                                                                        }));
                                                                    }}
                                                                >
                                                                    {VideoData.availableCategories.map((cat: any) => (
                                                                        <MenuItem key={cat.id} value={cat.id}>{cat.title}</MenuItem>
                                                                    ))}
                                                                </Select>
                                                            </FormControl>
                                                        </Box>
                                                    </Box>
                                                    <Box mb={2}>
                                                        <Autocomplete
                                                    
                                                            multiple
                                                            freeSolo
                                                            options={VideoData.availableTags || []}
                                                            value={VideoData.tags}
                                                            inputValue={inputValue}
                                                            onInputChange={(_, newInput) => {
                                                                if (newInput.includes('#') && newInput.trim()) {
                                                                    const hashtagMatches = newInput.match(/#[^\s#]+/g);

                                                                    if (hashtagMatches && hashtagMatches.length > 0) {
                                                                        const parts = newInput.split(/#/);
                                                                        const completeTags = [];
                                                                        let remaining = '';
                                                                        for (let i = 1; i < parts.length; i++) {
                                                                            const part = parts[i].trim();
                                                                            if (part.includes(' ') || part.includes('#') || i < parts.length - 1) {
                                                                                const tag = part.split(/[\s#]/)[0].trim();
                                                                                if (tag) completeTags.push(tag);
                                                                            } else {
                                                                                remaining = '#' + part;
                                                                            }
                                                                        }

                                                                        if (completeTags.length > 0) {
                                                                            const existingTags = VideoData.tags || [];
                                                                            const uniqueNewTags = completeTags.filter(tag => !existingTags.includes(tag));

                                                                            if (uniqueNewTags.length > 0) {
                                                                                setVideoData((prev: any) => ({
                                                                                    ...prev,
                                                                                    tags: [...prev.tags, ...uniqueNewTags],
                                                                                }));
                                                                            }
                                                                            setInputValue(remaining);
                                                                            return;
                                                                        }
                                                                    }
                                                                }
                                                                setInputValue(newInput);
                                                            }}
                                                            onChange={(_, newValue) => {
                                                                const processedValues = newValue.flatMap(val => {
                                                                    if (typeof val === 'string' && val.includes('#')) {
                                                                        // Split this value by hashtags only
                                                                        return val.split(/#/).map(t => t.trim()).filter(Boolean);
                                                                    }
                                                                    return val;
                                                                });

                                                                // Remove duplicates
                                                                const uniqueTags = Array.from(new Set(processedValues));

                                                                setVideoData((prev: any) => ({ ...prev, tags: uniqueTags }));
                                                            }}
                                                            filterSelectedOptions
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    sx={{ width: "90% !important" }}
                                                                    label="Tags"
                                                                    variant="outlined"
                                                                    className="textField"
                                                                    placeholder="Add or select tags"
                                                                    required
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === "Enter" || e.key === ",") {
                                                                            e.preventDefault();
                                                                            const input = inputValue.trim();
                                                                            if (input) {
                                                                                let newTags = [];

                                                                                if (input.includes('#')) {
                                                                                    newTags = input
                                                                                        .split(/[#,]+/)
                                                                                        .map((t) => t.trim())
                                                                                        .filter(Boolean);
                                                                                } else {
                                                                                    newTags = input
                                                                                        .split(/,+/)
                                                                                        .map((t) => t.trim())
                                                                                        .filter(Boolean);
                                                                                }

                                                                                const existingTags = VideoData.tags || [];
                                                                                const uniqueNewTags = newTags.filter(tag => !existingTags.includes(tag));

                                                                                if (uniqueNewTags.length > 0) {
                                                                                    setVideoData((prev: any) => ({
                                                                                        ...prev,
                                                                                        tags: [...prev.tags, ...uniqueNewTags],
                                                                                    }));
                                                                                }

                                                                                setInputValue("");
                                                                            }
                                                                        }
                                                                    }}
                                                                    onPaste={(e) => {
                                                                        e.preventDefault();
                                                                        const paste = e.clipboardData.getData("text");

                                                                        const newTags = paste
                                                                            .split(/[#,\n]+/)
                                                                            .map((t) => t.trim())
                                                                            .filter(Boolean);

                                                                        if (newTags.length) {
                                                                            const existingTags = VideoData.tags || [];
                                                                            const uniqueNewTags = newTags.filter(tag => !existingTags.includes(tag));

                                                                            if (uniqueNewTags.length > 0) {
                                                                                setVideoData((prev: any) => ({
                                                                                    ...prev,
                                                                                    tags: [...prev.tags, ...uniqueNewTags],
                                                                                }));
                                                                            }
                                                                        }

                                                                        setInputValue("");
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                    </Box>
                                                </>
                                   ):(
                                                <Box className="" sx={{ color: "#fff" }}>
                                                    {/* Kids Content */}
                                                    <Box mb={3}>
                                                        <FormControl className="textField">
                                                            <FormLabel className="formlabel" sx={{lineHeight: '20px'}}>
                                                                To meet child-safety rules, 'Made for Kids' content has some
                                                                features automatically restricted.
                                                            </FormLabel>
                                                            <RadioGroup
                                                                row
                                                                value={isForKids}
                                                                onChange={(e) => setIsForKids(e.target.value)}
                                                            >
                                                                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                                                                <FormControlLabel value="no" control={<Radio />} label="No" />
                                                            </RadioGroup>
                                                        </FormControl>
                                                    </Box>
                                                    <Box className="dateCategory">
                                                                
<LocalizationProvider dateAdapter={AdapterDayjs}>
  <DateTimePicker
    label="Schedule date & time"
    value={scheduleDateTime}
    onChange={(newValue:any) => {
    setScheduleDateTime(newValue);
    // If the user picks a time different from now, set the flag
    if (newValue && Math.abs(dayjs(newValue).diff(dayjs(), 'minute')) > 0) {
      setUserPickedTime(true);
    } else {
      setUserPickedTime(false);
    }
  }}
    className="textField"
    renderInput={(params:any) => (
      <TextField {...params} sx={{ width: "90% !important" }} />
    )}
  />
</LocalizationProvider>
                                                        </Box>

                                                    {/* Timezone */}
                                                    <Box mb={2} mt={4}>
                                                        <FormControl sx={{ width: "90% !important" }} className="textField">
                                                            <Autocomplete
                                                                options={uniqueTimezones}
                                                                getOptionLabel={(option) => option.label}
                                                                value={uniqueTimezones.find(tz => tz.name === selectedTimezone) || null}
                                                                onChange={(_, newValue) => setSelectedTimezone(newValue ? newValue.name : "")}
                                                                
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Select Timezone"
                                                                        // variant="outlined"
                                                                        placeholder="Search timezone"
                                                                    />
                                                                )}
                                                                isOptionEqualToValue={(option, value) => option.name === value.name}
                                                            />
                                                        </FormControl>
                                                    </Box>
                                                </Box>
                                            )}
                                        </Box>
                                        <Box className="width50">
                                            <>
                                                {videoUrl && (
                                                    <video src={videoUrl} controls className="videoPreview" />
                                                )}
                                                <Box className="" mt={4}>
                                                    <Box className="buttonEnds">
                                                        <SecondaryButton onClick={handlePreviousPage} disabled={!connected || publish}>
                                                            Previous
                                                        </SecondaryButton>
                                                        <ReusableButton
                                                            onClick={() => {
                                                                handlePublish()
                                                            }}
                                                            disabled={!connected || publish || !VideoData.title || !VideoData.description || !channelId || !VideoData.seletedCategory || !privateStatus}
                                                        >
                                                            {isFutureSchedule ? 'Schedule to Youtube' : 'Publish to Youtube'}
                                                        </ReusableButton>

                                                    </Box>
                                                </Box>
                                            </>
                                        </Box>
                                    </Box>

                                </>
                            )}
                        </Box>
                    </>
               ):(
                    <Box p={4} className="publishedContent">
                        <Typography variant="h6" className="youtubeText">
                            {selectedTimezone ? 'Successfully scheduled to youtube' : 'Successfully published to youtube'}
                        </Typography>
                        <Typography variant="body1" className="youtubeDescription">
                            Your youtube followers get notification of this video content published in AI content channel.
                        </Typography>
                        <img src={'/assets/YoutubeSuccess.svg'} alt="Youtube Success" className="youtubeSuccessImage" />
                        {publishUrl && (
                            <>
                                <Box className="youtubeLink">
                                    <Typography variant="body1" className="youtubeLinkText">
                                        {selectedTimezone ? 'Scheduled Video ' : 'Published Video '}
                                    </Typography>
                                    <IconButton onClick={() => handleCopyLink(publishUrl)}>
                                        <CopyAllOutlined />
                                    </IconButton>
                                </Box>
                                <Box>
                                    {getYouTubeVideoId(publishUrl) ? (
                                        <iframe
                                            width="100%"
                                            height="315"
                                            src={`https://www.youtube.com/embed/${getYouTubeVideoId(publishUrl)}`}
                                            title="YouTube video player"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                            className="videoPreview"
                                        />
                                    ) : (
                                        <video src={publishUrl} controls className="videoPreview" />
                                    )}
                                </Box>
                            </>
                        )}

                    </Box>
                )}
                {/* Only show Next/Previous buttons on the first two screens (not on publish screen) */}
                     {(connectedStatus === 'true' && !connected)  && (
                    <Box className="buttonEnd" display="flex" gap={2}>
                        <SecondaryButton onClick={handlePreviousPage} disabled={!connected || publish}>
                            Previous
                        </SecondaryButton>
                        <SecondaryButton
                            onClick={handleNextPage}
                            disabled={!isAnyChannelConnected() || connected || publish}
                        >
                            Next
                        </SecondaryButton>
                    </Box>
                )}
            </Dialog>
        </Box>
    );
};

export default YouTubePopup;
